import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISystemsSliceState } from './types';
import { ApiStatuses } from '../../app/types';
import {
  getSystem,
  getSystems,
} from './api';

export const initialState: ISystemsSliceState = {
  status: ApiStatuses.initial,
  systemStatus: ApiStatuses.initial,
  systems: []
};

export const fetchList = createAsyncThunk(
  'systems/fetchList',
  async (hasAccessToFetch: boolean) => {
    if (!hasAccessToFetch) return [];
    const response = await getSystems();
    return response.data;
  }
);

export const fetchSystem = createAsyncThunk(
  'systems/fetchSystem',
  async ({ systemId }: { systemId: number }) => {
    const response = await getSystem(systemId);
    return response.data;
  }
);

const slice = createSlice({
  name: "systems",
  initialState,
  reducers: {
    setSelectedSystem(state: ISystemsSliceState, action: PayloadAction<number>) {
      const selectedSystem = state.systems.find(s => s.id === action.payload);
      if (!selectedSystem) return;
      state.selectedSystem = { ...selectedSystem };
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchList
      .addCase(fetchList.pending, (state) => {
        state.status = ApiStatuses.loading;
      })
      .addCase(fetchList.fulfilled, (state, action) => {
        state.status = ApiStatuses.success;
        state.systems = action.payload;
      })
      .addCase(fetchList.rejected, (state) => {
        state.status = ApiStatuses.fail;
      })
      // fetchSystem
      .addCase(fetchSystem.pending, (state) => {
        state.systemStatus = ApiStatuses.loading;
      })
      .addCase(fetchSystem.fulfilled, (state, action) => {
        state.systemStatus = ApiStatuses.success;
        state.selectedSystem = action.payload;
      })
      .addCase(fetchSystem.rejected, (state) => {
        state.systemStatus = ApiStatuses.fail;
      })
  },
});

export const systems = slice.reducer;
export const actions = slice.actions;